import { gql } from "@apollo/client";

export const GetAllRolesQuery = gql`
  query Query {
    getAllRoles
  }
`;
